import { render, staticRenderFns } from "./backupDialog.vue?vue&type=template&id=65b71db6&scoped=true"
import script from "./backupDialog.vue?vue&type=script&lang=js"
export * from "./backupDialog.vue?vue&type=script&lang=js"
import style0 from "./backupDialog.vue?vue&type=style&index=0&id=65b71db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b71db6",
  null
  
)

export default component.exports